import uniqid from 'uniqid'
import { certs } from '../../portfolio'
import CertificationContainer from '../CertificationContainer/CertificationContainer'
import './Certifications.css'

const Certifications = () => {
  if (!certs.length) return null

  return (
    <section id='projects' className='section projects'>
      <h2 className='section__title'>Certifications</h2>

      <div className='projects__grid'>
        {certs.map((cert) => (
          <CertificationContainer key={uniqid()} cert={cert} />
        ))}
      </div>
    </section>
  )
}

export default Certifications
